// extracted by mini-css-extract-plugin
export default {"counter":"styles_counter__V7XNB","text_wrapper":"styles_text_wrapper__c8dzc","value":"styles_value__aU2GV","button":"styles_button__7E-xX"};